export default {
  title: "Invitación",
  description: "Has sido invitado a colaborar en un evento",
  status: {
    pending: "Pendiente",
    accepted: "Aceptada",
    declined: "Rechazada",
    expired: "Expirada"
  },
  resourceTypes: {
    budget: "Presupuesto",
    guests: "Invitados",
    tasks: "Tareas",
    timeline: "Cronología",
    vendors: "Proveedores",
    events: "Eventos"
  },
  accessLevels: {
    view: "Solo lectura",
    edit: "Edición",
    manage: "Gestión completa"
  },
  actions: {
    accept: "Aceptar",
    decline: "Rechazar"
  },
  accessLevel: "Nivel de acceso",
  expiresAt: "Expira el",
  invitedBy: "Invitado por",
  unknownUser: "Usuario desconocido",
  success: {
    accepted: "Invitación aceptada con éxito",
    declined: "Invitación rechazada"
  },
  errors: {
    invalidToken: "Token de invitación inválido",
    notFound: "Invitación no encontrada",
    expired: "Esta invitación ha expirado",
    accept: "Error al aceptar la invitación",
    decline: "Error al rechazar la invitación",
    loadInvitation: "Error al cargar la invitación",
    pendingInvitation: "Error al verificar las invitaciones pendientes"
  },
  landing: {
    welcome: "¡Bienvenido, {{name}}!",
    welcomeGeneric: "Acceso Compartido",
    subtitle: "Introduzca su correo electrónico para acceder a los recursos compartidos",
    subtitleAuthenticated: "Has sido invitado a colaborar en este evento.",
    confirmIdentity: "Confirme su identidad para acceder al espacio seguro reservado para",
    emailLabel: "Dirección de correo electrónico",
    emailPlaceholder: "tu@email.com",
    emailHelp: "Use la dirección de correo con la que recibió la invitación",
    submitButton: "Acceder al espacio",
    validating: "Validando...",
    securityTitle: "Información de seguridad",
    securityPoint1: "Este enlace es único y seguro",
    securityPoint2: "El acceso está estrictamente reservado al correo invitado",
    securityPoint3: "No se requiere creación de cuenta",
    errorToken: "Falta el token de intercambio en la URL",
    errorValidation: "Enlace no válido o correo electrónico incorrecto. Comprueba que estás utilizando la dirección correcta.",
    errorGeneric: "Ocurrió un error durante la validación"
  }
};
